export { EAreaOfBusinessActivities } from "../../types/rentDeposit.types";
export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Provider"] = "provider";
    EField["StartDate"] = "startDate";
    EField["Amount"] = "amount";
    EField["Info"] = "info";
    EField["DueDate"] = "dueDate";
    EField["Signers"] = "signers";
    EField["TenantSigners"] = "tenantSigners";
    EField["Payer"] = "payer";
    EField["Broker"] = "broker";
    EField["DocumentType"] = "documentType";
    EField["IdentityDocuments"] = "identityDocuments";
    EField["BanqupIdentityDocuments"] = "banqupIdentityDocuments";
    EField["PayerIdentityDocuments"] = "payerIdentityDocuments";
    EField["PayerIdentityDocumentAccountId"] = "payerAccountId";
    EField["IdentityDocumentAccountId"] = "accountId";
    EField["IdentityDocumentIdentityFrontDocumentId"] = "identityFrontDocument";
    EField["IdentityDocumentIdentityBackDocumentId"] = "identityBackDocument";
    EField["LegalContactInfo"] = "legalContactInfo";
    EField["SignAsBroker"] = "signAsBroker";
    EField["Locale"] = "locale";
    EField["MPLocale"] = "mpLocale";
    EField["DateOfExpiry"] = "dateOfExpiry";
    EField["DocumentNumber"] = "documentNumber";
    EField["CountryOfIssuance"] = "countryOfIssuance";
    EField["DateOfIssuance"] = "dateOfIssuance";
    // Company director fields (inside PayerIdentityDocuments array)
    EField["DirectorContactId"] = "directorContactId";
    EField["ShareholderPercentage"] = "shareholderPercentage";
    EField["Occupation"] = "occupation";
    // Company KYB section (top-level, shown after identity docs)
    EField["CompanyKybHeader"] = "_companyKybHeader";
    EField["BusinessRegisterInfoBanner"] = "businessRegisterInfoBanner";
    EField["UboRegisterInfoBanner"] = "uboRegisterInfoBanner";
    EField["LegalForm"] = "legalForm";
    EField["DateOfIncorporation"] = "dateOfIncorporation";
    EField["PrimaryBusinessActivity"] = "primaryBusinessActivity";
    EField["AreaOfBusinessActivities"] = "areaOfBusinessActivities";
    EField["BusinessRegisterDocument"] = "businessRegisterDocument";
    EField["UboRegisterDocument"] = "uboRegisterDocument";
    EField["InsuranceSendProposal"] = "insuranceSendProposal";
    EField["InsuranceDataSharing"] = "insuranceDataSharing";
    EField["InsuranceContractRentPrice"] = "insuranceContractRentPrice";
    EField["InsuranceBuildingSurfaceArea"] = "insuranceBuildingSurfaceArea";
    EField["InsuranceBuildingLayers"] = "insuranceBuildingLayers";
    EField["InsuranceBuildingAdjoined"] = "insuranceBuildingAdjoined";
    EField["InsuranceBuildingHasHardMaterials"] = "insuranceBuildingHasHardMaterials";
})(EField || (EField = {}));
export var EBanqupRentioDocumentType;
(function (EBanqupRentioDocumentType) {
    EBanqupRentioDocumentType["IdCard"] = "ID_CARD";
    EBanqupRentioDocumentType["Passport"] = "PASSPORT";
})(EBanqupRentioDocumentType || (EBanqupRentioDocumentType = {}));
